/* eslint-disable wrap-iife */
(function($) {
  'use strict';

  var mediaQuery = window.matchMedia('(min-width: 37.5em)'),
    minHeightDesktop = 300,
    minHeightMobile = 750,
    animationDuration = 300,
    $infoBlocks = $('.info-block'),
    $infoToggles = $infoBlocks.find('.info-block__toggle');

  function resizeInfoBlocks() {
    var minHeight = mediaQuery.matches ? minHeightDesktop : minHeightMobile;

    $infoBlocks.each(function() {
      var $elem = $(this),
        $content = $elem.find('.info-block__content'),
        contentHeight =
          $content.find('*:last-child').position().top +
          $content.find('*:last-child').outerHeight();

      if (contentHeight < minHeight) {
        $elem.find('.info-block__controls').hide();
      } else {
        $elem.find('.info-block__controls').show();
        $content.css({ height: minHeight }).attr('tabindex', null);
      }
    });
  }

  function toggleContent($elem) {
    var minHeight = mediaQuery.matches ? minHeightDesktop : minHeightMobile,
      $currentBlock = $($elem.closest('.info-block')),
      $blockContent = $currentBlock.find('.info-block__content'),
      maxHeight =
        $blockContent.find('*:last-child').position().top +
        $blockContent.find('*:last-child').outerHeight();

    if ($currentBlock.hasClass('active')) {
      $elem.text('Show more');

      $blockContent.animate(
        { height: minHeight },
        animationDuration,
        function() {
          $elem.attr('aria-expanded', 'false').focus();
        }
      );

      $currentBlock.removeClass('active');
      $blockContent.attr('tabindex', null);
    } else {
      $elem.html('Show less');

      $blockContent.animate({ height: maxHeight }, animationDuration);

      $currentBlock.addClass('active');
      $elem.attr('aria-expanded', 'true');
      $blockContent.attr('tabindex', '-1').focus();
    }
  }

  // Initialise event listeners
  $infoToggles.on('click', function(e) {
    e.preventDefault();
    var $toggle = $(this);
    $toggle.blur();
    toggleContent($toggle);
  });

  // Update components that don't need the toggle button
  resizeInfoBlocks();
})(jQuery);
